
        var result = require("!!../../../../node_modules/css-loader/index.js!./employee-create.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/employees/employee-details/employee-create.component.css
// module id = 2427
// module chunks = 1